<template>
    <div class="home">
        <HomeBanner></HomeBanner>
        <div v-once class="home-title">
            <div class="home-title-text">东瀛民宿，日本民宿/酒店/接送机预订平台。</div>
            <div class="home-title-text">東瀛民宿，日本民泊/ホテル/送迎の予約サイト。</div>
        </div>
        <HomeCardContent name="热门目的地" sub-name="人気の目的地" :data-list="cityList"></HomeCardContent>
        <HomeCardContent name="推荐房源" :show-more="'/tokyoHouse'" sub-name="お勧めの宿" :data-list="recommendHouse" :type="2"></HomeCardContent>
        <HomeCardContent name="实惠之旅" sub-name="お得の旅" :data-list="recommendLine" :type="3"></HomeCardContent>
        <HomeCardContent name="温泉酒店" :show-more="'/tokyoHouse'" sub-name="温泉ホテル" :data-list="springHouse" :type="4"></HomeCardContent>
    </div>
</template>

<script>
    // @ is an alias to /src
    import HomeBanner from "@/components/HomeBanner";
    import HomeCardContent from "@/components/HomeCardContent";

    export default {
        name: 'Home',
        components: {HomeBanner, HomeCardContent},
        data(){
            return {
                cityList:[],
                recommendHouse: [],
                recommendLine: [],
                springHouse: [],
            }
        },
        created(){
            this.getCityList();
            this.getRecommendHouse();
            this.getRecommendLine()
            this.getSpringHouse()
        },
        methods:{
            async getCityList(){
                let [e, data] = await this.$api.getCityListApi();
                this.$store.commit('saveCityList', data.result)
                this.cityList = data.result.filter(it => it.hot)
            },
            async getRecommendHouse(){
                let [e, data] = await this.$api.getRecommendHouseApi()
                this.recommendHouse = data.result
            },
            async getRecommendLine(){
                let [e, data] = await this.$api.getRecommendLineApi()
                this.recommendLine = data.result
            },
            async getSpringHouse(){
                let [e, data] = await this.$api.getSpringHouseApi()
                this.springHouse = data.result
            },
        }
    }
</script>
<style scoped lang="less">
    .home{
        width: 100%;
        .home-title{
            font-style: italic;
            margin: 40px 0 20px 0;
            .home-title-text{
                color: #e44646;
                font-size: 28px;
                padding: 6px 0;
                text-align: center;
                span{
                    font-size: 28px;
                }
            }
            .home-title-sub{
                color: #949494;
                font-size: 18px;
                text-align: center;
            }
        }
    }
</style>
